/*
 * サブシステム名：
 * 機能名：受注・実績一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
// import validators from '@/rahmen/validators'

import d2fmt from '@/ddv2.library/utils/formatter'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
// import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdDropDown from '@/components/DdDropDown'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdMonthBox from '@/components/DdMonthBox'
import DdMonthBoxInside from '@/components/DdMonthBoxInside'
import DdRadioButton from '@/components/DdRadioButton'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTransparentButton from '@/components/DdTransparentButton'

export default {
  name: 'HaishaMeisaiListEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDateRangeBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdMonthBox,
    DdMonthBoxInside,
    DdRadioButton,
    DdSpreadSheet,
    DdSubHeader,
    DdSwitch,
    DdTransparentButton
  },
  data: () => ({
    isConditionHide: false,
    isAfterSearch: false,
    isEditCategory: false,
    isShowHaishaOutputDialog: false,
    isShowNohinshoOutputDialog: false,
    isShowOutputDialog: false,
    isXlsDownloader: false,

    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,

    // 検索用
    conditions: {},
    conditionDetails: [
      { key: 'mstSharyoId', name: '車両', value: 'sharyoNm', delete: true },
      { key: 'hasseiYmdFromTo', name: '発生年月日', value: 'hasseiYmdFromTo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'keijoYmdFromTo', name: '計上年月日', value: 'keijoYmdFromTo', type: 'value', delete: true, showValue: true, convertValue: false }
    ],
    searchText: null,

    // 表示用
    headers: [],
    rows: [],

    // 保存用
    selected: [],
    targetList: [],
    // 制御用運行実績ID（新規の場合は-1から減らしていく）
    newRecordId: 0,

    // 権限
    modeKengen: 0,

    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '100%',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列固定
      freezeColumns: 1,
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: true,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100, 150, 200],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 車両
    'conditions.mstSharyoId': function (n) {
      if ([undefined, null, ''].includes(this.conditions.mstSharyoId)) {
        this.conditions.sharyoNm = null
      } else {
        const m = this.sharyoList.find(x => x.id === this.conditions.mstSharyoId)
        if (m !== null) {
          this.conditions.sharyoNm = m.jidoshaHyojiNm
        } else {
          this.conditions.sharyoNm = null
        }
      }
    },
    // 発生年月日
    'conditions.hasseiStartYmdString': function (n) {
      var hasseiYmdFromTo = ![undefined, null, ''].includes(this.conditions.hasseiStartYmdString) ? this.conditions.hasseiStartYmdString.slice(-5) : ''
      hasseiYmdFromTo = hasseiYmdFromTo + (![undefined, null, ''].includes(this.conditions.hasseiEndYmdString) ? '～' + this.conditions.hasseiEndYmdString.slice(-5) : '')
      this.conditions.hasseiYmdFromTo = hasseiYmdFromTo
    },
    'conditions.hasseiEndYmdString': function (n) {
      var hasseiYmdFromTo = ![undefined, null, ''].includes(this.conditions.hasseiStartYmdString) ? this.conditions.hasseiStartYmdString.slice(-5) : ''
      hasseiYmdFromTo = hasseiYmdFromTo + (![undefined, null, ''].includes(this.conditions.hasseiEndYmdString) ? '～' + this.conditions.hasseiEndYmdString.slice(-5) : '')
      this.conditions.hasseiYmdFromTo = hasseiYmdFromTo
    },
    // 計上年月日
    'conditions.keijoStartYmdString': function (n) {
      var keijoYmdFromTo = ![undefined, null, ''].includes(this.conditions.keijoStartYmdString) ? this.conditions.keijoStartYmdString.slice(-5) : ''
      keijoYmdFromTo = keijoYmdFromTo + (![undefined, null, ''].includes(this.conditions.keijoEndYmdString) ? '～' + this.conditions.keijoEndYmdString.slice(-5) : '')
      this.conditions.keijoYmdFromTo = keijoYmdFromTo
    },
    'conditions.keijoEndYmdString': function (n) {
      var keijoYmdFromTo = ![undefined, null, ''].includes(this.conditions.keijoStartYmdString) ? this.conditions.keijoStartYmdString.slice(-5) : ''
      keijoYmdFromTo = keijoYmdFromTo + (![undefined, null, ''].includes(this.conditions.keijoEndYmdString) ? '～' + this.conditions.keijoEndYmdString.slice(-5) : '')
      this.conditions.keijoYmdFromTo = keijoYmdFromTo
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      return !this.eigyoshoLockFlg
    },
    // ----------------------------------------------------------------------------------------------------
    // 検索条件用フィルタ
    // ----------------------------------------------------------------------------------------------------
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 車両フィルタ
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.hacchusakiFlg === false && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 乗務員フィルター
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 傭車先
    filteredShiiresakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.shiiresakiFlg === true
      })
    },

    computedInputRows () {
      return this.rows.length
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const errorRows = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg === true
      })
      if (errorRows.length > 0) {
        return true
      }

      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'vwcmstsharyo', 'mstshubetsu', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        // 表示用
        sharyoId: null,
        hasseiStartYmdString: null,
        hasseiEndYmdString: null,
        keijoStartYmdString: null,
        keijoEndYmdString: null
      }
      this.isAfterSearch = false
      this.searchText = ''
      this.rows = []
      this.page = 1
    },

    onClearButtonClick: function () {
      this.clear()
      this.setHeader()
    },
    clear: function () {
      this.initBindVariables()
      this.rows = []
      this.isConditionHide = false
    },
    onSearchButtonClick: function () {
      this.$nextTick(() => {
        this.searchAction(false)
      })
    },
    onRemoveConditionClick: function (itemNm) {
      if (itemNm === 'hasseiYmdFromTo') {
        this.conditions.hasseiStartYmdString = null
        this.conditions.hasseiEndYmdString = null
      } else if (itemNm === 'keijoYmdFromTo') {
        this.conditions.keijoStartYmdString = null
        this.conditions.keijoEndYmdString = null
      } else {
        this.conditions[itemNm] = null
      }
      this.$nextTick(() => {
        this.searchAction(false)
      })
    },
    searchAction: function (noMessage) {
      this.rows = []
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd2010/search', self.conditions)
              .then((data) => {
                self.setHeader()
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          const resultData = data.payload
          // 検索結果保持用にセット
          resultData.map((elem, index) => {
            // スプレッドシート用にここで編集
            elem.rowNo = index + 1
            elem.errFlg = false
            elem.editMode = false

            // 取得したレコードはすべて変更扱いとする（登録時に全件送るため）
            elem.editFlg = false

            // ここから表示用編集
            elem.hasseiYmd = ![undefined, null, ''].includes(elem.hasseiYmd) ? filter.dateFormatter(elem.hasseiYmd) : ''
            elem.keijoYmd = ![undefined, null, ''].includes(elem.keijoYmd) ? filter.dateFormatter(elem.keijoYmd) : ''
            elem.insDate = ![undefined, null, ''].includes(elem.insDate) ? filter.dateFormatter(elem.insDate) : ''

            // 経費金額関数埋め込み
            const y = index + 1
            elem.keihiKingakuFormula = `=IF(I${y}="",K${y},I${y}*K${y})`

            return elem
          })
          self.rows = resultData

          self.isConditionHide = true
          self.isAfterSearch = true
        },
        isNoMessageModeMethod: function () {
          return noMessage
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureValidateMethod: function () {
        }
      }
      this.search(opt)
    },
    // 検索前チェック
    searchValidate: function () {
      return true
    },

    // 登録前チェック
    registerValidate: function () {
      const self = this
      const filledRows = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true && ![undefined, null, ''].includes(elem.mstSharyoNm)
      })

      let noProblem = true

      filledRows.forEach((row, rowIndex) => {
        self.headers.forEach((col, colIndex) => {
          if (col.isRequired) {
            const cellValue = row[col.name]
            const isEmpty = cellValue === null || cellValue === ''
            const cellName = self.$refs.ddSpreadSheet.getCellNameFromCoords(colIndex, rowIndex)

            if (isEmpty) {
              noProblem = false
              // 見た目にわかるよう赤背景をつける
              self.$refs.ddSpreadSheet.jspreadsheetObj.setStyle(cellName, 'background-color', '#ffcccc')
            } else {
              // 問題なければ背景を戻す（任意）
              self.$refs.ddSpreadSheet.jspreadsheetObj.setStyle(cellName, 'background-color', '')
            }
          }
        })
      })

      return noProblem
    },

    /**
     * 一覧ヘッダ作成
     */
    setHeader: function () {
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        const target = filter.dateFormatter(new Date())

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 車両
        var wkSharyoList = ['未選択']
        const mSharyoList = self.sharyoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })
        const tSharyoList = mSharyoList.map(elem => {
          return elem.jidoshaHyojiNm
        })
        wkSharyoList = wkSharyoList.concat(tSharyoList)

        // 営業所
        var wkEigyoshoList = ['未選択']
        const mEigyoshoLisst = self.eigyoshoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })
        const tEigyoshoList = mEigyoshoLisst.map(elem => {
          return elem.eigyoshoNm
        })
        wkEigyoshoList = wkEigyoshoList.concat(tEigyoshoList)

        // 仕入先
        var wkShiiresakiList = ['未選択']
        const mShiiresakiList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.shiiresakiFlg
        })
        const tShiiresakiList = mShiiresakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkShiiresakiList = wkShiiresakiList.concat(tShiiresakiList)

        // 車両整備区分
        var wkSharyoSeibiKbnList = ['未選択']
        const mSharyoSeibiKbnList = self.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF056' && elem.kaishaCd === self.currentKaishaCode
        })
        const tSharyoSeibiKbnList = mSharyoSeibiKbnList.map(elem => {
          return elem.codeNm
        })
        wkSharyoSeibiKbnList = wkSharyoSeibiKbnList.concat(tSharyoSeibiKbnList)

        // 車両整備単位区分
        var wkTaniShubetsuList = ['未選択']
        const mTaniShubetsuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SVI001' && elem.kaishaCd === self.currentKaishaCode
        })
        const tTaniShubetsuList = mTaniShubetsuList.map(elem => {
          return elem.sbtNm
        })
        wkTaniShubetsuList = wkTaniShubetsuList.concat(tTaniShubetsuList)

        // --------------------------------------------------------------------------------
        // スプレッド用ヘッダ作成
        // --------------------------------------------------------------------------------
        self.headers = [
          // ----------
          { title: '車両', name: 'mstSharyoNm', type: 'dropdown', source: wkSharyoList, required: false, isRequired: true, readOnly: false, width: '150px', autocomplete: true },
          { title: '発生年月日', name: 'hasseiYmd', type: 'date', validateType: 'Date', required: false, isRequired: true, readOnly: false, width: '110px', align: 'center' },
          { title: '計上年月日', name: 'keijoYmd', type: 'date', validateType: 'Date', required: false, isRequired: true, readOnly: false, width: '110px', align: 'center' },
          { title: '実績確認', name: 'jissekiKakuninZumiFlg', type: 'checkbox', customInput: null, width: '80px' },
          { title: '実績締め', name: 'jissekiShimeFlg', type: 'checkbox', customInput: null, width: '80px' },
          { title: '取引先', name: 'torihikisakiNm', type: 'dropdown', source: wkShiiresakiList, required: false, isRequired: true, readOnly: false, width: '150px', autocomplete: true },
          { title: '営業所', name: 'keihiEigyoshoNm', type: 'dropdown', source: wkEigyoshoList, required: false, isRequired: true, readOnly: false, width: '150px', autocomplete: true },
          { title: '車両整備区分', name: 'sharyoSeibiKeihiKbnNm', type: 'dropdown', source: wkSharyoSeibiKbnList, required: false, readOnly: false, width: '100px', autocomplete: true },
          { title: '数量', name: 'suryo', type: null, customInput: 'numeric', validateIntDigit: 11, validateDecimalDigit: 2, validateType: 'Numerical', readOnly: false, width: '100px', align: 'right' },
          { title: '単位', name: 'sharyoSeibiTaniKbnNm', type: 'dropdown', source: wkTaniShubetsuList, required: false, readOnly: false, width: '100px', align: 'right', autocomplete: true },
          { title: '単価', name: 'keihiTanka', type: null, customInput: 'numeric', customInputIntDigit: 11, customInputDecimalDigit: 0, validateType: 'Numerical', required: false, isRequired: true, readOnly: false, width: '120px', align: 'right', mask: '#,##0 円' },
          { title: '経費金額', name: 'keihiKingakuFormula', type: null, customInput: 'numeric', customInputIntDigit: 11, customInputDecimalDigit: 0, required: false, readOnly: true, width: '120px', align: 'right', mask: '#,##0 円' },
          { title: 'オドメータ', name: 'odoMater', type: null, customInput: 'numeric', customInputIntDigit: 7, customInputDecimalDigit: 0, validateType: 'Numerical', required: false, readOnly: false, align: 'right', width: '120px' },
          { title: '社内備考', name: 'shanaiBiko', type: 'text', validateType: 'Free', validateLength: 10, customInput: null, required: false, readOnly: false, width: '250px' },
          { title: '入力日', name: 'insDate', type: 'date', validateType: 'Date', required: false, isRequired: false, readOnly: true, width: '110px', align: 'center' },
          { title: '入力担当者', name: 'nyuryokuTantoshaNm', type: 'text', validateType: 'Free', validateLength: 50, customInput: null, required: false, readOnly: true, width: '180px' }
        ]

        resolve()
      })
    },

    /**
     * 読み取り専用設定
     */
    setReadonlyCell: function (rowData, columnName) {
      if (this.isShoukaiMode) {
        return true
      }

      return false
    },

    /**
     * 行制御
     */
    // 行追加 上
    rowAppendAvobe: function (num) {
      this.rowAppend(num, true)
    },
    // 行追加
    onAddRow: function () {
      const newrows = this.setNewRow()
      const y = this.rows.length + 1
      newrows.keihiKingakuFormula = `=IF(I${y}="",K${y}, I${y}*K${y})`
      this.rows.push(newrows)
    },
    rowAppend: function (num, aboveFlg) {
      // 現在の選択セル
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 行追加先の位置を取得
      var pos = 0
      var posMax = 0
      // 全選択状態なら先頭行に追加
      var isAllSelect = false
      if (!activeC) {
        // セル未選択
      } else if (activeC.length > 3) {
        // セル選択 ※先頭行を基準とする
        pos = Math.min(...[activeC[1], activeC[3]])
        // 複数行制御用に最終行も取得
        posMax = Math.max(...[activeC[1], activeC[3]])

        // 全選択かどうか判定
        var isSame1 = activeC[0] === 0
        var isSame2 = activeC[1] === 0
        var isSame3 = activeC[2] === this.headers.length - 1
        var isSame4 = activeC[3] === this.rows.length - 1
        isAllSelect = isSame1 && isSame2 && isSame3 && isSame4
      }

      const appendCount = posMax - pos + num ? num : 1
      const newrows = Array.from({ length: appendCount }, () => this.setNewRow())

      // 行追加
      if (isAllSelect || (aboveFlg !== undefined && aboveFlg)) {
        if (pos === 0) {
          this.rows.unshift(...newrows)
          pos = 0
        } else {
          this.rows.splice(pos, 0, ...newrows)
        }
      } else {
        if (![undefined, null, 0].includes(pos)) {
          this.rows.splice(pos + 1, 0, ...newrows)
        } else {
          this.rows.splice(this.rows.length, 0, ...newrows)
        }
      }

      // 行番号が狂うので外部からのエラー設定は消去
      this.outsideErrorList = []

      // 行追加後のセルを選択状態にしてあげる…準備
      this.selectTargetPosition = pos + 1

      // 計算式関数見直し
      this.rows.forEach((rec, index) => {
        const y = index + 1
        rec.keihiKingakuFormula = `=IF(I${y}="",K${y}, I${y}*K${y})`
      })
    },
    // 行削除
    rowDelete: function (num, index) {
      console.log('rowDelete : ', num, index, this.rows)

      // 現在の選択セル
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 行追加先の位置を取得
      var pos = 0
      var posMax = 0
      if (activeC.length > 3) {
        // セル選択 ※先頭行を基準とする
        pos = Math.min(...[activeC[1], activeC[3]])
        // 複数行制御用に最終行も取得
        posMax = Math.max(...[activeC[1], activeC[3]])

        // データを削除
        this.rows.splice(pos, (posMax - pos + 1))
        this.rows = [...this.rows]
        this.$forceUpdate()
      }
    },

    onLoadDataAfter () {
      // このタイミングでやるのがまぁ正しいんでしょう
    },
    setNewRow () {
      // const userEigyoshoNm = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).eigyoshoNm
      this.newRecordId -= 1
      return {
        id: this.newRecordId,
        hasseiYmd: null,
        keijoYmd: null,
        jissekiKakuninZumiFlg: false,
        jissekiShimeFlg: false,
        torihikisakiNm: null,
        keihiEigyoshoNm: null,
        sharyoSeibiKeihiKbnNm: null,
        suryo: null,
        sharyoSeibiTaniKbnNm: null,
        keihiTanka: null,
        keihiKingakuFormula: null,
        odoMater: null,
        shanaiBiko: null,
        insDate: date.getCurrentDate()
      }
    },

    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // console.log('c', rowData, cell, x, y, newValue, oldValue)
    },
    /**
     * 行追加後イベント
     * @param {} rowNumber
     */
    rowAddAfter (rowNumber) {
    },

    /**
     * 保存処理（ソースが酷いのでそのうち直す）
     * @returns
     */
    onMultiSaveButtonClick: function () {
      const self = this

      // 変更フラグONのみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true && ![undefined, null, ''].includes(elem.mstSharyoNm)
      })
      if (saveTargetRow.length < 1) {
        modals.showToast('保存対象がありません', null, 500, null, 'warning')
        return
      }

      // DB保存用変換
      saveTargetRow.map((elem) => {
        // 数値変換
        elem.odoMater = ![null, ''].includes(elem.odoMater) ? d2fmt.removeComma(elem.odoMater) : null
        elem.suryo = ![null, ''].includes(elem.suryo) ? d2fmt.removeComma(elem.suryo) : null
        elem.keihiTanka = ![null, ''].includes(elem.keihiTanka) ? d2fmt.removeComma(elem.keihiTanka) : null
        elem.keihiKingaku = ![null, ''].includes(elem.suryo) && ![null, ''].includes(elem.keihiTanka) ? (elem.suryo * elem.keihiTanka) : [null, ''].includes(elem.suryo) && ![null, ''].includes(elem.keihiTanka) ? elem.keihiTanka : null

        return elem
      })

      /**
       * リスト項目テキスト⇒ID/Code変換
       */
      // 車両変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.mstSharyoNm)
      }).map((elem) => {
        const m = self.sharyoList.filter(function (item) {
          return item.jidoshaHyojiNm === elem.mstSharyoNm
        })
        if (m.length > 0) {
          elem.mstSharyoId = m[0].id
        } else {
          elem.mstSharyoId = null
        }
        return elem
      })

      // 取引先
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.torihikisakiNm)
      }).map((elem) => {
        const m = self.torihikisakiList.filter(function (item) {
          return item.torihikisakiNm === elem.torihikisakiNm
        })
        if (m.length > 0) {
          elem.torihikisakiId = m[0].id
        } else {
          elem.torihikisakiId = null
        }
        return elem
      })

      // 営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null, ''].includes(elem.keihiEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm === elem.keihiEigyoshoNm
        })
        if (m.length > 0) {
          elem.keihiEigyoshoId = m[0].id
        }
        return elem
      })

      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.sharyoSeibiKeihiKbnNm)
      }).map((elem) => {
        const m = self.kubunList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'SFF056' && item.codeNm === elem.sharyoSeibiKeihiKbnNm
        })
        if (m.length > 0) {
          elem.sharyoSeibiKeihiKbn = m[0].code
        } else {
          elem.sharyoSeibiKeihiKbn = null
        }
        return elem
      })

      // 車両整備単位区分
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.sharyoSeibiTaniKbnNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SVI001' && item.sbtNm === elem.sharyoSeibiTaniKbnNm
        })
        if (m.length > 0) {
          elem.sharyoSeibiTaniKbn = m[0].sbtCd
        } else {
          elem.sharyoSeibiTaniKbn = null
        }
        return elem
      })

      /**
       * 保存処理
       */
      this.targetList = saveTargetRow
      this.$nextTick(function () {
        self.saveAction()
      })
    },

    saveAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.put('/api/v1/VwCD2prmd2010/BatchRegister', self.targetList)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()

            this.$nextTick(function () {
              this.searchAction(true)
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    convertOutputStringToDecimal: function (val) {
      if ([undefined, null, ''].includes(val)) return null
      if (!isNaN(val)) return val
      return d2fmt.removeComma(val.replace(' 円', ''))
    },

    /**
     * EXCEL出力
     */
    onXlsOutputButtonClick: function (e) {
      this.isXlsDownloader = true

      this.Effects.loadStart()

      const self = this
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2prmd2010/ExcelOutput', self.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          self.Effects.loadComplete()
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '配車表_' + ts + '.xlsx'
          elem.click()
        })
    },

    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
